import { get } from './api'
import { ICalendar } from 'pages/my-calendars/add-calendar'

export interface CalendarTypes {
    activeInd: boolean
    createdAt: string
    createdBy: string
    dates: string[]
    endDate: string
    id: string
    startDate: string
    typeName: string
    updatedAt: string
    updatedBy: string
}

export const getCalendar = (suplierId: string, calendarId: string): Promise<ICalendar> => {
    return get({ url: `/api/suppliers/${suplierId}/calendars/${calendarId}` })
}

export const getFilteredCalendars = ({
    supplierId,
    authors,
    status,
    types
}: {
    supplierId: string
    authors?: string[]
    status?: 'Worksheet' | 'Approved'
    types?: string
}): Promise<ICalendar[]> => {
    const authorsParams = authors ? authors.map((el: string) => `authors=${el}&`).join() : ''
    return get<ICalendar[]>({
        url: `/api/suppliers/${supplierId}/calendars?${authorsParams}${
            status ? `status=${status}&` : ''
        }${types ? `types=${types}` : ''}`
    })
}
